import React, { useContext, useState } from "react";
import ProfileCommonView from "./Common/View";
import { AuthContext, IntlContext } from "context";
import ProfileCompanyView from "./Company/View";
import { Role } from "types/user";
import { deleteMyAccount } from "hooks/profile";
import Button from "ui/Button";
import ConfirmModal from "ui/Modal/ConfirmModal";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import { getServerMessage } from "lib/serverError";
import { toast } from "sonner";

interface Props {
    onClickHandleMode: () => void;
}

const View: React.FC<Props> = ({ onClickHandleMode }) => {
    const { logout, account, currentRole } = useContext(AuthContext);
    const intl = useContext(IntlContext);
    const [displayDeleteModal, setDisplayDeleteModal] = useState(false);

    const handleDelete = async () => {
        try {
            await deleteMyAccount();
            logout();
        } catch (err: unknown) {
            toast.error(
                getServerMessage(err) ?? intl.formatMessage("profile.account.action.delete.error"),
            );
        }
    };

    if (Role.COMPANY === account!.user.roles[0]) {
        return (
            <div className="register container">
                <div className="register__container">
                    <div className="flex flex--justify-content-flex-end">
                        <Button className="btn btn--primary" onClick={onClickHandleMode}>
                            <Icon icon={{ prefix: "fas", iconName: "pencil" }} className="icon--left" />
                            {intl.formatMessage("generic.action.edit_profil")}
                        </Button>
                    </div>
                    <ProfileCompanyView />
                </div>
            </div>
        );
    }

    return (
        <React.Fragment>
            <div className="flex flex--justify-content-flex-end">
                {(currentRole === Role.PROVIDER || currentRole === Role.CLIENT) && (
                    <Button className="btn btn--primary" onClick={onClickHandleMode}>
                        <Icon icon={{ prefix: "fas", iconName: "pencil" }} className="icon--left" />
                        {intl.formatMessage("generic.action.edit")}
                    </Button>
                )}
            </div>
            <ProfileCommonView />
            <div className="text-center margin-top--8">
                <Button className="btn btn--cancel" onClick={() => setDisplayDeleteModal(true)}>
                    {intl.formatMessage("profile.account.action.delete")}
                </Button>
                {currentRole === Role.PROVIDER && (
                    <div className="comment margin-top--2">
                        <span className="profile--provider_mandatory_field">Date de naissance</span> / <span className="profile--provider_mandatory_field">Ville de naissance</span> / <span className="profile--provider_mandatory_field">N° de sécurité sociale</span> : champs obligatoires pour activer la publication de vos services.
                    </div>
                )}
            </div>

            <ConfirmModal
                show={displayDeleteModal}
                onClose={() => setDisplayDeleteModal(false)}
                onConfirm={() => handleDelete()}
                title={intl.formatMessage("profile.account.action.delete.modal.title")}
                message={intl.formatMessage("profile.account.action.delete.modal.message")}
                confirmButton={intl.formatMessage("generic.label.delete")}
                cancelButton={intl.formatMessage("generic.action.cancel")}
            />
        </React.Fragment>
    );
};

export default View;
